// // components/JoinChat.js
// import React, { useEffect, useState } from 'react';

// import whatsappLogo from "../assets/whatsapp.png"

// const JoinChat = ({
//   phone = '4402080400335',
//   message = 'Hi! I’d like to know more about your services.',
//   delay = 3000,
//   showOnDesktop = true,
// }) => {
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setVisible(true);
//     }, delay);
//     return () => clearTimeout(timer);
//   }, [delay]);

//   const openWhatsApp = () => {
//     const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
//     window.open(url, '_blank');
//   };

//   const isMobile = /iPhone|Android|iPad|iPod/i.test(navigator.userAgent);
//   if (!showOnDesktop && !isMobile) return null;

//   return visible ? (
//     <div
//       style={{
//         position: 'fixed',
//         bottom: '20px',
//         right: '20px',
//         zIndex: 9999,
//         cursor: 'pointer',
//         borderRadius: '20px',
//       }}
//       onClick={openWhatsApp}
//     >
//       <img
//         src={whatsappLogo}
//         alt="Chat on WhatsApp"
//         style={{
//             width: '60px',
//             transition: 'transform 0.3s ease-in-out',
//         }}
//         onMouseEnter={e => {
//             e.currentTarget.style.transform = 'scale(1.1)';
//         }}
//         onMouseLeave={e => {
//             e.currentTarget.style.transform = 'scale(1)';
//         }}
// />

//     </div>
//   ) : null;
// };

// export default JoinChat;



import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'; // 👈 Add this line!

import whatsappLogo from "../assets/whatsapp.png"

const JoinChat = ({
  phone = '4402080400335',
  message = 'Hi! I’d like to know more about your services.',
  delay = 3000,
  showOnDesktop = true,
}) => {
  const [visible, setVisible] = useState(false);
  const location = useLocation(); // 👈 Use location here

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, delay);
    return () => clearTimeout(timer);
  }, [delay]);

  const openWhatsApp = () => {
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  const isMobile = /iPhone|Android|iPad|iPod/i.test(navigator.userAgent);

  // ❌ Hide JoinChat completely if on /verify/*
  if (location.pathname.startsWith('/verify')) {
    return null;
  }

  if (!showOnDesktop && !isMobile) return null;

  return visible ? (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
        cursor: 'pointer',
        borderRadius: '20px',
      }}
      onClick={openWhatsApp}
    >
      <img
        src={whatsappLogo}
        alt="Chat on WhatsApp"
        style={{
            width: '60px',
            transition: 'transform 0.3s ease-in-out',
        }}
        onMouseEnter={e => {
            e.currentTarget.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={e => {
            e.currentTarget.style.transform = 'scale(1)';
        }}
      />
    </div>
  ) : null;
};

export default JoinChat;
